import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { getCompanyMood } from '../../../Actions/analytics.actions';

import CompanyMoodCard from './companyMoodCard';
import MoreInsightsCard from './moreInsightsCard';
import GlobalFilters from '../../../Components/globalFilters';
import { BreadCrumbContainer } from '../../../SharedStyles/BreadCrumbContainer';
import LocationPath from '../../../Components/locationPath';
import { paths } from '..';
import NewStyledSelect from '../../../SharedStyles/newStyledSelect';
import copyToClipboard from '../../../Util/clipboard';
import { useTranslation } from 'react-i18next';

const CompanyMoodPage = ({ isRequired = false }) => {
  const [period, setPeriod] = useState('year');
  const [departmentId, setDepartmentId] = useState('0');
  const [subDepartmentId, setSubDepartmentId] = useState('0');
  const [location, setLocation] = useState('0');
  const [compareprevious, setCompareprevious] = useState(0);
  const [sortByMoreInsights, setSortByMoreInsights] = useState('age');
  const { t } = useTranslation();
  const data = useSelector((store) => store.analytics?.companyMood?.data, undefined);

  const dispatch = useDispatch();
  const visibility_constant = useSelector((store) => store.company?.visibility_constant);
  const showDemographics = useSelector((store) => store.company?.profile?.show_demographic_graphs);

  const onPeriodChange = (p) => {
    setPeriod(p);
    // setLoadingDashboard(true);
    // dispatch(getCompanyMood({ period: p, department_id: departmentId })).finally(() => setLoadingDashboard(false));
  };

  const handleChange = (value, setValue) => {
    copyToClipboard(value, setValue);
  };

  const onSelectChange = (id) => {
    const departmentId = id;
    setDepartmentId(departmentId);
    // setLoadingDashboard(true);
    // dispatch(getCompanyMood({ period, department_id: departmentId })).finally(() => setLoadingDashboard(false));
  };
  const onSubDeptChange = (id) => {
    setSubDepartmentId(id);
  };

  const onLocationChange = (id) => {
    const locationId = id;
    setLocation(locationId);
    // setLoadingDashboard(true);
    // dispatch(getCompanyMood({ period, department_id: departmentId })).finally(() => setLoadingDashboard(false));
  };

  useEffect(() => {
    dispatch(
      getCompanyMood({
        period,
        department_id: departmentId,
        subdepartment_id: subDepartmentId,
        compare_previous: compareprevious,
        insight_type: sortByMoreInsights,
        country_id: location,
      }),
    );
  }, [dispatch, period, departmentId, subDepartmentId, location, compareprevious, sortByMoreInsights]);

  return (
    <>
      {/* {data === undefined ? (
        <HoverWrapper>
          <Loading />
        </HoverWrapper>
      ) : null} */}
      {/* <FiltersWrapper>
        <GlobalFilters period={period} onPeriodChange={onPeriodChange} onSelectChange={onSelectChange} />
      </FiltersWrapper> */}
      <BreadCrumbContainer>
        <LocationPath styles={{ margin: 0 }} multi paths={paths} pathName={t('analytics')} />
        <StyledDiv>
          <NewStyledSelect onChange={handleChange} isRequired />

          <GlobalFilters
            period={period}
            onPeriodChange={onPeriodChange}
            department={departmentId}
            onSubDeptChange={onSubDeptChange}
            onSelectChange={onSelectChange}
            onLocationChange={onLocationChange}
          />
        </StyledDiv>
      </BreadCrumbContainer>
      <MobileMargin />
      <div className="copyFullImage">
        <div className="copyChartElement">
          <CompanyMoodCard period={period} setCompareprevious={setCompareprevious} />
        </div>

        {visibility_constant && showDemographics === 1 && (
          <div className="copyDemographicInsights">
            <MoreInsightsCard
              globalFilters={{ department_id: departmentId, period }}
              setSortByMoreInsights={setSortByMoreInsights}
              sortByMoreInsights={sortByMoreInsights}
            />
          </div>
        )}
      </div>
    </>
  );
};

const StyledDiv = styled.div`
  display: flex;
  justify-content: end;
  gap: 10px;
`;

const HoverWrapper = styled.div`
  position: absolute;
  z-index: 1000;
  background: #ffffffc7;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
`;

const MobileMargin = styled.div`
  width: 100%;
  height: 1px;
  margin-bottom: 0;

  @media screen and (max-width: 715px) {
    margin-bottom: 30px;
  }
`;

const FiltersWrapper = styled.div`
  position: absolute;
  right: 30px;
  top: 18px;

  @media screen and (max-width: 715px) {
    top: 60px;
    left: 25px;
  }
`;

export default memo(CompanyMoodPage);
